import { CanActivateFn } from '@angular/router';
import { environment } from '@environments/environment';

export function registerGuard(): CanActivateFn {
    return async () => {
        const registerUrl = `${environment.registerUrl}?response_type=token&client_id=${environment.auth0.clientId}&redirect_uri=${window.location.protocol}//${window.location.host}&screen_hint=signup`;
        window.location.href = registerUrl;
        return false;
    };
}
